import * as era from '!/era'
import { ui } from '!/skin'
import { Skeleton } from '@/ui/components/Skeleton'
import { useUnit } from 'effector-react'
import type { JSX } from 'react'
import { libraryFavoritesWidget } from '~/widgets/library/favorites'
import { libraryPurchasedWidget } from '~/widgets/library/purchased'
import { $contentLoading } from './skeleton'

export const skin = era.skin('routes/library/root')

LibraryPage.displayName = 'LibraryPage'
export function LibraryPage(): JSX.Element {
  const isContentLoading = useUnit($contentLoading)
  const isFavoritesInited = useUnit(
    libraryFavoritesWidget.$isFavoritesContentInited
  )
  const isPurchasedInited = useUnit(
    libraryPurchasedWidget.$isPurchasedContentInited
  )

  const isTabsLoading =
    isContentLoading && (!isFavoritesInited || !isPurchasedInited)

  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper className={`flex-column`}>
        <ui.RenderSkin name='libraryTitle' />
        <Skeleton pageType='categoriesTabs' isLoading={isTabsLoading}>
          <ui.RenderSkin name='libraryTabs' />
        </Skeleton>
        <Skeleton pageType='category' isLoading={isContentLoading}>
          <ui.RenderSkin name='libraryTvChannels' />
          <ui.RenderSkin name='libraryMovies' />
          <ui.RenderSkin name='libraryTvShows' />
          <ui.RenderSkin name='libraryLiveEvents' />
          <ui.RenderSkin name='libraryEmptyPage' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
